import { render, staticRenderFns } from "./EventosAlertas.vue?vue&type=template&id=7eae71db&scoped=true"
import script from "./EventosAlertas.vue?vue&type=script&lang=js"
export * from "./EventosAlertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eae71db",
  null
  
)

export default component.exports